module.exports = __webpack_public_path__ + "img/ic_profil.881ffa64.svg";